import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"

import api from "../../../api";
import auth from '../../../auth/';

import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Label, Input, FormFeedback } from 'reactstrap';

import AgregarCampo from "./AgregarCampo.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaFileUploader from "../../../components/paradigmaFileUploader/ParadigmaFileUploader.js"
import ParadigmaCKEditor from '../../../components/ParadigmaCKEditor/ParadigmaCKEditor.js'

class Edit extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.references = [];
        this.state = {
            solicitud_id: null,
            marco_id: null,
            tipo_id: null,
            subtipo_id: null,
            tabs: [],
            errors_tabs: {},
            activeTab: '0',
            urlsubtipo: null,
            file:{
                 name:null,
                 link:null
            }
        };

        this.EraseFile=this.EraseFile.bind(this);
        this.AppendDocument=this.AppendDocument.bind(this);
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            solicitud_id: data.solicitud_id,
            marco_id: data.marco_id,
            tipo_id: data.tipo_id,
            subtipo_id: data.subtipo_id,
            tabs: data.campos,
            activeTab: '0',
            urlsubtipo: (data.tipo_id != 0 && data.tipo_id != null ? api.proyectos.config.plan.subtipos.select + "?tipo=" + data.tipo_id : null),
            file:{
                 name: data.file.name !== undefined && data.file.name !== null ? data.file.name : null,
                 link: data.file.link !== undefined && data.file.link !== null ? api.BASE_URL + data.file.link : null
            }
        });
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    onChangeInput(tabN, input) {
        var i = parseInt(tabN);
        var tabs = this.state.tabs;
        tabs[i].value = input.value;
        this.setState({ tabs: tabs });
    }

    getActiveClass(tabN) {
        if (this.state.activeTab == tabN)
            return "active";
        else
            return "";
    }

    addTab(campo) {
        var tabs = this.state.tabs;
        tabs.push({
            nombre: campo.campo_nombre,
            campo_id: parseInt(campo.campo_id),
            value: "",
            obligatorio: false,
        });
        this.setState({ tabs: tabs });
    }

    removeTab(e, campo_id) {
        e.preventDefault();
        var tabs = this.state.tabs.filter(x => x.campo_id != campo_id);
        this.setState({ tabs: tabs });
    }

    EraseFile(evt){
         this.setState({
              file:{
                   name:null,
                   link:null
              }
         });
    }

    AppendDocument(evt){
         if(evt.target.files !== undefined && evt.target.files.length == 1){
              let file = evt.target.files[0];
              this.setState({
                        file:{
                             name:file.name,
                             link:null
                        }
                   });
         }
    }

    killEditors(){
         this.references.forEach(
              function(reference) {
                   if(reference.current){
                        reference.current.killEditor();
                   }
              });
    }

    onValidation(){
         let result = true;
         this.references.forEach(
              function(reference) {
                   if(reference.current){
                        result &= reference.current.onValidation();
                   }
              });
              return result;
    }

    render() {
        var tabhead = [];
        var tabpanel = [];
        this.references = [];

        if (this.state.tabs) {
            for (var i = 0; i < this.state.tabs.length; i++) {
                var tab = this.state.tabs[i];
                let tabN = i.toString();
                let reference = React.createRef();
                this.references.push(reference);
                tabhead.push(
                    <NavItem key={tabN}>
                        <NavLink className={this.getActiveClass(tabN)} onClick={() => { this.toggle(tabN); }}>
                            {tab.nombre}
                            {tab.obligatorio == false && <button type="button" onClick={(e) => { this.removeTab(e, tab.campo_id) }} className={"ml-1"}><i className={"fa fa-times"} /></button>}
                        </NavLink>
                    </NavItem>
                );
                tabpanel.push(
                    <TabPane tabId={tabN} className="py-0" key={tabN}>
                        <Row>
                            <Col className="col-12 p-0">
                                <Input type="number" name={"tabs[" + tabN + "][id]"} className="p-0 d-none" value={tab.campo_id} onChange={(e) => this.onChangeInput(tabN, e.target)} />
                                <ParadigmaCKEditor
                                     readOnly={false}
                                     id = {"tabs[" + tabN + "][id]"}
                                     ref = {reference}
                                     isInForm={true}
                                     name={"tabs[" + tabN + "][valor]"}
                                     value={tab.value}
                                     onValueChange={ (value) => this.onChangeInput(tabN, value)}
                                     className="GrowingEditor"
                                     filebrowserImageUploadUrl = {api.misc.pictureUploadURL}
                                     fileTools_requestHeaders = { auth.header().headers }
                                     maxLength = {25000}
                                />
                            </Col>
                        </Row>
                    </TabPane>
                );
            }

            tabhead.push(
                <NavItem key={this.state.tabs.length + 1}>
                    <AgregarCampo tabs={this.state.tabs} onSubmit={(data) => this.addTab(data)} />
                </NavItem>
            )
        }

        return (
            <ParadigmaModal
               fileUploader={true}
                getUrl={api.proyectos.plandetrabajo.edit}
                postUrl={api.proyectos.plandetrabajo.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Plan de Trabajo ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Plan de Trabajo"}
                buttonTitle={"Editar Plan de Trabajo"}
                buttonIcon={"fa fa-pencil fa-lg"}
                className = "modalTabulado ui-modal-dialog ui-modal-editor"
                notAllowedMessage={"El Plan de Trabajo no puede ser editado en esta etapa porque ya fue cerrado."}
                saveButton={true}
                closeButton={true}
                onClose={() => this.killEditors()}
                onGotData={(data) => this.setSelects(data)}>
                <div className="ui-form">
                <p className="ui-section-label">Datos del proyecto</p>
                <div className="ui-row-1">
                    <div className="ui-field">
                        <Label>Proyecto</Label>
                        <ParadigmaAsyncSeeker clearable={false} fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select} onChange={(data) => this.setState({ solicitud_id: data.pk })} value={this.state.solicitud_id} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                </div>
                <div className="ui-row-2">
                    <div className="ui-field">
                        <Label>Tipo de Transferencia</Label>
                        <ParadigmaAsyncSeeker clearable={false} fieldName={"tipo_id"} url={api.proyectos.config.plan.tipos.select} onChange={(data) => this.setState({ tipo_id: (data ? data.pk : 0), subtipo_id: 0 })} value={this.state.tipo_id} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                    <div className="ui-field">
                        <Label>Subtipo de Transferencia</Label>
                        <ParadigmaAsyncSeeker clearable={false} disabled={(this.state.tipo_id ? false : true)} fieldName={"subtipo_id"} url={api.proyectos.config.plan.subtipos.select + "?tipo=" + (this.state.tipo_id ? this.state.tipo_id : 0)} onChange={(data) => this.setState({ subtipo_id: (data ? data.pk : 0) })} value={this.state.subtipo_id} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                </div>
                <div className="ui-row-1">
                    <div className="ui-field">
                        <Label>Modo de Vinculación</Label>
                        <ParadigmaAsyncSeeker clearable={false} fieldName={"marco_id"} url={api.proyectos.config.plan.marcos.select} onChange={(data) => this.setState({ marco_id: data.pk })} value={this.state.marco_id} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                </div>

                <div className="ui-divider"></div>
                <div className="ui-row-1">
                    <div className="ui-field">
                        <Label>Requisitos</Label>
                        <ParadigmaFileUploader
                        name="InformeAdjunto"
                        onChange = {this.AppendDocument}
                        erase = {this.EraseFile}
                        link = {this.state.file.link}
                        filename = {this.state.file.name}
                        acceptExtension = {"application/pdf"}
                        linkMessage={" Adjunto (.pdf): "}
                        />

                        <Nav tabs>
                            {tabhead}
                        </Nav>

                        <TabContent activeTab={this.state.activeTab}>
                            {tabpanel}
                        </TabContent>
                    </div>
                </div>

                <div className="ui-divider"></div>
                <div className="ui-row-1">
                    <div className="ui-field">
                        <Label>Observaciones</Label>
                        <Input type="textarea" name="observaciones" />
                        <FormFeedback className="col-12"></FormFeedback>
                    </div>
                </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento2/Edit.js